// Libs
import React from "react";
import { Route, Redirect } from "react-router-dom";

// Components/Containers
import App from "./containers/App";
import Auth from "./containers/Auth";
import Capture from "./containers/Capture";
import Company from "./containers/Company";
import Dashboard from "./containers/Dashboard";
import Deauth from "./containers/Deauth";
import ForgetPwPage from "./containers/ForgetPwPage";
import Importer from "./containers/Importer";
import ImporterLawyer from "./containers/ImporterLawyer";
import Home from "./containers/Home";
import NewInicialPage from "./containers/NewInicialPage";
import NewInvitationPage from "./containers/NewInvitationPage";
import MyCasesPage from "./containers/MyCasesPage";
import PaymentPage from "./containers/PaymentPage";
import ProfilePage from "./containers/ProfilePage";
import SignInPage from "./containers/SignInPage";
import SignUpPage from "./containers/SignUpPage";
import SlidePage from "./containers/SlidePage";
import SpCasePage from "./containers/SpCasePage";
import TermsOfUse from "./containers/TermsOfUse";
import Tour from "./containers/Tour";
import WelcomePage from "./containers/WelcomePage";
import DownloadKroton from "./containers/DownloadKroton";
import PrivacyPolicy from "./containers/PrivacyPolicy";
// HOC
import AuthRequire from "./hoc/AuthRequire";
import Dpo from "./containers/Dpo";

let PrivateRoute = ({ children }) => (
  <AuthRequire>
    <Auth>{children}</Auth>
  </AuthRequire>
);

const Routes = (
  <App>
    <Route exact path="/">
      <Home />
    </Route>
    <Route path="/empresa">
      <Company />
    </Route>
    <Route path="/termos-de-uso">
      <TermsOfUse />
    </Route>
    <Route path="/dpo">
      <Dpo />
    </Route>
    <Route path="/aviso-de-privacidade">
      <PrivacyPolicy />
    </Route>
    <Route exact path="/login">
      <Deauth>
        <SignInPage />
      </Deauth>
    </Route>
    <Route exact path="/login/:base64">
      <Deauth>
        <SignInPage />
      </Deauth>
    </Route>
    <Route exact path="/login/:email/:password">
      <Deauth>
        <SignInPage />
      </Deauth>
    </Route>
    <Route exact path="/login/:email/:password/:type">
      <Deauth>
        <SignInPage />
      </Deauth>
    </Route>
    <Route exact path="/login/:email/:password/:type/:channel">
      <Deauth>
        <SignInPage />
      </Deauth>
    </Route>

    <Route path="/cadastro">
      <Deauth>
        <SignUpPage />
      </Deauth>
    </Route>
    <Route path="/esqueci-minha-senha">
      <Deauth>
        <ForgetPwPage />
      </Deauth>
    </Route>

    <Route path="/download-capture-zip/:lawsuitNumber">
      <DownloadKroton />
    </Route>
    <Route exact path="/tour/:slide">
      <PrivateRoute>
        <Tour>
          <SlidePage />
        </Tour>
      </PrivateRoute>
    </Route>
    <Route exact path="/tour">
      <Redirect to="/tour/1" />
    </Route>
    <Route path="/dashboard">
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    </Route>
    <Route path="/captacao">
      <PrivateRoute>
        <Capture />
      </PrivateRoute>
    </Route>
    <Route path="/inserir-caso-pre-contencioso">
      <PrivateRoute>
        <NewInicialPage />
      </PrivateRoute>
    </Route>
    <Route exact path="/inserir-caso-contencioso">
      <PrivateRoute>
        <NewInvitationPage />
      </PrivateRoute>
    </Route>
    <Route exact path="/inserir-caso-contencioso/importar">
      <PrivateRoute>
        <Importer />
      </PrivateRoute>
    </Route>
    <Route path="/perfil">
      <Redirect to="/perfil/alterar-informacoes" />
    </Route>
    <Route path="/perfil/alterar-informacoes">
      <PrivateRoute>
        <ProfilePage />
      </PrivateRoute>
    </Route>
    <Route path="/perfil/pagamento">
      <PrivateRoute>
        <PaymentPage />
      </PrivateRoute>
    </Route>
    <Route exact path="/meus-casos">
      <PrivateRoute>
        <MyCasesPage />
      </PrivateRoute>
    </Route>
    <Route exact path="/meus-casos/:spCase">
      <PrivateRoute>
        <SpCasePage />
      </PrivateRoute>
    </Route>
    <Route exact path="/meus-casos/:spCase/:channel">
      <PrivateRoute>
        <SpCasePage />
      </PrivateRoute>
    </Route>
    <Route path="/importador/contatos">
      <PrivateRoute>
        <ImporterLawyer />
      </PrivateRoute>
    </Route>
  </App>
);

export default Routes;
